import React from "react";
import type { ComponentProps, PartData } from "@enonic/react-components";

import { formatPublishDate } from "/react4xp/components/shared/lib/Utils";
import type { PublishDatePartProps } from "./PublishDate.d";

export const PublishDatePart = (props: ComponentProps<PartData>) => {
  const { publishDate } = (props.data as PublishDatePartProps) ?? {};

  return (
    publishDate && (
      <div className="container event-location">
        Publisert {formatPublishDate(publishDate)}
      </div>
    )
  );
};

export default PublishDatePart;
